/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SummaryChannelResponse } from './SummaryChannelResponse';
import {
    SummaryChannelResponseFromJSON,
    SummaryChannelResponseFromJSONTyped,
    SummaryChannelResponseToJSON,
    SummaryChannelResponseToJSONTyped,
} from './SummaryChannelResponse';
import type { SummaryRevenuesResponse } from './SummaryRevenuesResponse';
import {
    SummaryRevenuesResponseFromJSON,
    SummaryRevenuesResponseFromJSONTyped,
    SummaryRevenuesResponseToJSON,
    SummaryRevenuesResponseToJSONTyped,
} from './SummaryRevenuesResponse';

/**
 * 
 * @export
 * @interface FinancialSummaryResponse
 */
export interface FinancialSummaryResponse {
    /**
     * 
     * @type {Array<SummaryChannelResponse>}
     * @memberof FinancialSummaryResponse
     */
    cancelled?: Array<SummaryChannelResponse>;
    /**
     * 
     * @type {Array<SummaryChannelResponse>}
     * @memberof FinancialSummaryResponse
     */
    awaitingPayment?: Array<SummaryChannelResponse>;
    /**
     * 
     * @type {SummaryRevenuesResponse}
     * @memberof FinancialSummaryResponse
     */
    revenues?: SummaryRevenuesResponse;
    /**
     * 
     * @type {number}
     * @memberof FinancialSummaryResponse
     */
    totalSum?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialSummaryResponse
     */
    totalCount?: number;
}

/**
 * Check if a given object implements the FinancialSummaryResponse interface.
 */
export function instanceOfFinancialSummaryResponse(value: object): value is FinancialSummaryResponse {
    return true;
}

export function FinancialSummaryResponseFromJSON(json: any): FinancialSummaryResponse {
    return FinancialSummaryResponseFromJSONTyped(json, false);
}

export function FinancialSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'cancelled': json['cancelled'] == null ? undefined : ((json['cancelled'] as Array<any>).map(SummaryChannelResponseFromJSON)),
        'awaitingPayment': json['awaitingPayment'] == null ? undefined : ((json['awaitingPayment'] as Array<any>).map(SummaryChannelResponseFromJSON)),
        'revenues': json['revenues'] == null ? undefined : SummaryRevenuesResponseFromJSON(json['revenues']),
        'totalSum': json['totalSum'] == null ? undefined : json['totalSum'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
    };
}

export function FinancialSummaryResponseToJSON(json: any): FinancialSummaryResponse {
    return FinancialSummaryResponseToJSONTyped(json, false);
}

export function FinancialSummaryResponseToJSONTyped(value?: FinancialSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cancelled': value['cancelled'] == null ? undefined : ((value['cancelled'] as Array<any>).map(SummaryChannelResponseToJSON)),
        'awaitingPayment': value['awaitingPayment'] == null ? undefined : ((value['awaitingPayment'] as Array<any>).map(SummaryChannelResponseToJSON)),
        'revenues': SummaryRevenuesResponseToJSON(value['revenues']),
        'totalSum': value['totalSum'],
        'totalCount': value['totalCount'],
    };
}

